import { REQUEST_STATUSES } from "@/constants/index.js";

const initialState = {
  hotspots: [],
  status: REQUEST_STATUSES.IDLE,
  err: null,
};
export const hotspotsSelector = (state) => ({
  ...initialState,
  ...(state.hotspots || {}),
});
